module.exports = __webpack_public_path__ + "img/thailand.4be7d1ba.svg";